/**
 * Config pública de auth (GET /auth/config).
 *
 * PÚBLICO (sin sesión): devuelve SÓLO claves públicas — el client id de Google
 * (OAuth) y la site key de reCAPTCHA v3. NUNCA el secret. Strings vacíos si no
 * están configuradas en el panel Super Admin: en ese caso el botón de Google no
 * se muestra y el captcha no se ejecuta (feature off, no rompe nada).
 *
 * `skipAuthRefresh:true` para que un eventual 401 no dispare el ciclo de refresh
 * (no hay sesión que renovar en el login/registro).
 */
import { useQuery } from '@tanstack/react-query';

import { api } from '../api';

export interface AuthConfig {
  google_client_id: string;
  recaptcha_site_key: string;
  /** ¿Pago con tarjeta habilitado? Gatea el sello de Bancard en el footer público. */
  card_enabled: boolean;
}

export function useAuthConfig() {
  return useQuery({
    queryKey: ['auth', 'config'],
    queryFn: () => api.get<AuthConfig>('/auth/config', { skipAuthRefresh: true }),
    // Config estable: cacheamos varios minutos.
    staleTime: 5 * 60_000,
    retry: 1,
  });
}
